import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableCell,
  TableRow,
  TextField,
  TableBody,
  Typography,
  Grid,
  Box,
  FormGroup,
  FormControlLabel,
  FormControl,
  InputLabel
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { upperCase } from "lodash";
import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useAnnouncements } from "./AnnoucementsContext";
import { createAnnouncement, deleteAnnouncement, saveAnnouncement } from "./utils";
import QuillEditor from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import imageResize from 'quill-image-resize-module-react';
import Quill from 'quill';
Quill.register('modules/imageResize', imageResize);

const AnnouncementForm = () => {
  const [open, setOpen] = useState(false);

  const [formErrors, setFormErrors] = useState({})

  const {
    announcement,
    filterValues,
    selectedAnnoucement,
    setSelectedAnnouncement,
    setReload,
    setAnnouncement,
    events,
    adminWebFiles,
    setEvents,
    selectedEventBtn,
    setSelectedEventBtn,
    setAdminWebFiles,
    
  } = useAnnouncements();
  const quill = useRef();
  useEffect(() => {
    setOpen(selectedAnnoucement !== null || setAnnouncement!==null);
  }, [selectedAnnoucement,announcement]);


 const imageHandler = useCallback(() => {
        const input = document.createElement('input');
        input.setAttribute('type','file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = () => {
            const file = input.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                const imageUrl = reader.result;
                const quillEditor = quill.current.getEditor();

                const range = quillEditor.getSelection(true);

                quillEditor.insertEmbed(range.index, 'image', imageUrl, 'user');
            };
            reader.readAsDataURL(file);
        };
    }, []);

  const modules = useMemo(
          () => ({
              toolbar: {
                  container: [
                      [{ header: [2,3,4, false] }],
                      ['bold', 'italic', 'underline', 'blockquote'],
                      [{color: []}],
                      [
                          {list: 'ordered'},
                          {list: 'bullet'},
                          {indent: '-1'},
                          {indent: '+1'},
                      ],
                      ['link', 'image'],
                      ['clean'],
                  ],
                  handlers: {
                      image: imageHandler,
                  },
              },
              imageResize : {
                parchment: Quill.import('parchment'),
                modules: ['Resize', 'DisplaySize'],
              },
              clipboard: {
                  matchVisual: true,
              },
          }),
          [imageHandler]
      );
  
      const formats = [
          'header',
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'list',
          'bullet',
          'indent',
          'link',
          'image',
          'color',
          'clean',
          'custom-image',
          'style',
          'width',
          'height'
      ];



  const handleChange = (e) => {
    const name = e.target.name.toLowerCase();
    const value = e.target.value;  
    setAnnouncement((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdminWebfiles = () => {
    setAdminWebFiles(true)
  }
  const handleEventBtn =(e) => {
    setSelectedEventBtn(true)
  }


  const formValidate = (selectedAnnoucement) => {

      let newFormErrors = {};

      if(selectedAnnoucement.title===null || (selectedAnnoucement.title).trim() ===""){
        newFormErrors.title="Please Enter title"
        setFormErrors(newFormErrors)
        // return false
      }
      if(!selectedAnnoucement.highPriorityPage && !selectedAnnoucement.newsItem && !selectedAnnoucement.siteNews && !selectedAnnoucement.construction && !selectedAnnoucement.transit && !selectedAnnoucement.weather && !selectedAnnoucement.trucker)
      {
        newFormErrors.type="Select type of the announcement"
        setFormErrors(newFormErrors)
        // return false
      }

      if(Object.keys(newFormErrors).length>0)
          return false

      else
        return true
  }

  const saveAnnc = (selectedAnnoucement) => {

    if (formValidate(selectedAnnoucement)){
  
    if(selectedAnnoucement.id===null)
      createAnnouncement(selectedAnnoucement).then(() => {
        setSelectedAnnouncement(null);
        setAnnouncement(null);
        setReload(true);
        setFormErrors({})
      });
    else  
    saveAnnouncement(selectedAnnoucement).then(() => {
      setSelectedAnnouncement(null);
      setAnnouncement(null);
      setReload(true);
      setFormErrors({})
    });
  }
  // else
  //   alert("Please make sure input the required fields before submit");
  };

  const deleteAnnc = (selectedAnnoucement) => {
    deleteAnnouncement(selectedAnnoucement).then(() => {
      setSelectedAnnouncement(null);
      setAnnouncement(null);
      setReload(true);
    });
  };

  const onClose = (e, reason) => {
    setSelectedAnnouncement(null);
    setAnnouncement(null);
    setEvents(null);
    setFormErrors({})
  };
  var title="New Announcement"
  var eventIds="";
  if(announcement){
        if(announcement.id)
            title="Edit Announcement"
        if(announcement.eventIds && announcement.eventIds.length>0)
            eventIds=announcement.eventIds[0];
  }
  return (
    announcement && (
      <Dialog   maxWidth="true" open={open} onClose={onClose}>
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            right: 20,
            top: 8,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Card sx={{ borderRadius: 3, overflow: "auto" }}>
          <CardHeader
            title={<font className="layer-title"> {title} </font>}
            align="center"
            className={"styledtablerow"}
          />
          <DescriptionBlock/>
          <CardContent
            sx={{
              paddingTop: 1,
              paddingLeft: 0,
              paddingRight: 0, 
            }}
          >
            {/* <Box maxWidth= '1000px' sx={{paddingTop:3, paddingLeft:2, justifyContent:'center'}} border={1}>    */}
            <Box component="form" size='small'
                sx={{ '& .MuiTextField-root': { m: 1, width: '35ch' }, paddingTop:3, align:'center', }} >
              <Grid  container spacing={{ xs: 1}} sx={{ justifyContent:'center'}}  >
                <Grid>
                  <Table size="small">
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField
                          disabled
                          size="small"
                          id="announcement-id"
                          label="ID"
                          value={announcement.id}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="tablecellnoborder" >
                        <TextField fullWidth 
                        required
                          id="announcement-title"
                          label="Title"
                          size="small"
                          name="title"
                          type="text"
                          error={formErrors.title}
                          helperText={formErrors.title}
                          value={announcement.title}
                          onChange={handleChange}
                        />
                        {/* {formErrors.title && <Typography><span style={{color:'red'}}>{formErrors.title}</span></Typography>} */}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{paddingLeft:3}} className={"tablecellnoborder"}>
                        <FormControl fullWidth>
                          <InputLabel id="message-Icon-label"> Icon </InputLabel>
                          <Select  size="small"
                            labelId="admin-web-files"
                            label="Icon"
                            id="Admin web files"
                            name="icon"
                            value={announcement.icon}
                            // onChange={handleAdminWebfiles}
                            onChange={handleChange}
                          >
                            {adminWebFiles.map((eachChild) => (
                                <MenuItem
                                  value={eachChild.path}
                                  key={upperCase(eachChild.id)}
                                >
                                  {eachChild.path}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField fullWidth
                          size="small"
                          id="announcement-link"
                          label="Link"
                          name="link"
                          value={announcement.link}
                          onChange={handleChange}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField
                          fullWidth
                          disabled
                          size="small"
                          id="announcement-created-date"
                          label="Created Date"
                          value={announcement.creationDate}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <DatePicker
                          id="announcement-expiration-date"
                          label="Expiration Date" 
                          value={announcement.expirationDate}
                          onChange={(newValue) => {
                            setAnnouncement((announcement) => {
                              return { ...announcement, expirationDate: newValue };
                            });
                          }}
                          renderInput={(params) => <TextField size='small' {...params} error={false}/>}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField size="small" 
                          fullWidth
                          id="announcement-author"
                          label="Author"
                          name="author"
                          value={announcement.author}
                          onChange={handleChange}
                        />
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
                <Grid >
                  <Table size="small">
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField size="small"
                          id="announcement-agency"
                          label="Agency"
                          name="agency"
                          value={announcement.agency}
                          onChange={handleChange}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField size="small"
                          id="announcement-roadway"
                          label="Roadway"
                          name="roadway"
                          value={announcement.roadway}
                          onChange={handleChange}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField size="small"
                          id="announcement-state"
                          label="State"
                          name="state"
                          value={announcement.state}
                          onChange={handleChange}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField size="small"
                          id="announcement-state2"
                          label="State2"
                          name="state2"
                          value={announcement.state2}
                          onChange={handleChange}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField size="small"
                          id="announcement-weatherGovId"
                          label="Weather Gov ID"
                          name="weatherDotGovId"
                          value={announcement.weatherDotGovId}
                          onChange={handleChange}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <TextField size="small"
                          id="announcement-high-prioritypageorder"
                          label="High Priority Page Order"
                          value={announcement.highPriorityPageOrder}
                          onChange={(e) => {
                            setAnnouncement((announcement) => {
                              return {
                                ...announcement,
                                highPriorityPageOrder: e.target.value,
                              };
                            });
                          }}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{paddingLeft:3}} className={"tablecellnoborder"}>
                        <FormControl>
                          <InputLabel id="message-Priority-label"> Priority </InputLabel>
                          <Select size="small"
                            labelId="announcementPriority-label"
                            id="priority-selection"
                            label="Priority"
                            value={announcement.priority}  
                            onChange={handleChange}
                            name="Priority"
                          >
                            {filterValues.priorities.map((eachpriority) => (
                              <MenuItem
                                value={upperCase(eachpriority)}
                                key={upperCase(eachpriority)}
                              >
                                {upperCase(eachpriority)}{" "}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
                <Grid size={8}>
                  {formErrors.type && <Typography><span style={{color:'red'}}>{formErrors.type}</span></Typography>}
                  <Table size="small">
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <FormGroup>
                          <FormControlLabel 
                            control={<Checkbox checked={announcement.highPriorityPage} onChange={(e) => {
                              setAnnouncement((announcement) => {
                                return {
                                  ...announcement,
                                  highPriorityPage: !announcement.highPriorityPage,
                                };
                              });
                            }}/>} 
                            label="High Priority Page" 
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <FormGroup>
                          <FormControlLabel 
                            control={<Checkbox checked={announcement.newsItem} onChange={(e) => {
                            setAnnouncement((announcement) => {
                              return {
                                ...announcement,
                                newsItem: !announcement.newsItem,
                              };
                            });
                            }}/>} 
                            label="News Item" 
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <FormGroup>
                          <FormControlLabel 
                            control={<Checkbox checked={announcement.siteNews} onChange={(e) => {
                              setAnnouncement((announcement) => {
                                return {
                                  ...announcement,
                                  siteNews: !announcement.siteNews,
                                };
                              });
                            }}/>} 
                            label="Site News" 
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <FormGroup>
                          <FormControlLabel 
                            control={<Checkbox checked={announcement.construction} onChange={(e) => {
                              setAnnouncement((announcement) => {
                                return {
                                  ...announcement,
                                  construction: !announcement.construction,
                                };
                              });
                            }}/>} 
                            label="Construction" 
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <FormGroup>
                          <FormControlLabel 
                            control={<Checkbox checked={announcement.transit} onChange={(e) => {
                              setAnnouncement((announcement) => {
                                return {
                                  ...announcement,
                                  transit: !announcement.transit,
                                };
                              });
                            }}/>} 
                            label="Transit" 
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <FormGroup>
                          <FormControlLabel 
                            control={<Checkbox checked={announcement.weather} onChange={(e) => {
                              setAnnouncement((announcement) => {
                                return {
                                  ...announcement,
                                  weather: !announcement.weather,
                                };
                              });
                            }}/>} 
                            label="Weather" 
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        <FormGroup>
                          <FormControlLabel 
                            control={<Checkbox checked={announcement.trucker} onChange={(e) => {
                              setAnnouncement((announcement) => {
                                return {
                                  ...announcement,
                                  trucker: !announcement.trucker,
                                };
                              });
                            }}/>} 
                            label="Trucker" 
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"tablecellnoborder"}>
                        {(announcement.eventIds && announcement.eventIds.length>0 && <Typography>{JSON.stringify(announcement.eventIds)}</Typography>)}
                          <Button variant="outlined" label="SelectEvents" name="eventIds" value={announcement.eventIds} onClick={handleEventBtn}> Select Events </Button>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
              </Grid>
            </Box>
            <Table>
              <TableRow>
                 <QuillEditor 
                    ref={(el)=> (quill.current =el)}
                    className='editor'
                    theme='snow'
                    name="html"
                    value={announcement.html}
                    formats={formats}
                    modules={modules}
                    onChange={(value) => setAnnouncement((announcement) => {
                    return {
                    ...announcement,
                    html: value,
                    };
                    })}
                  />
              </TableRow>
            </Table>
            <Table sx={{marginY:5}}>
              <TableBody>
                <TableRow>
                  <TableCell align="right">
                    <Button
                      name="Save Announcement"
                      label="Save Announcement"
                      variant="outlined"
                      size="small"
                      onClick={(e) => saveAnnc(announcement)}
                    >
                      Save Announcement
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      name="Delete Announcement"
                      label="Delete Announcement"
                      variant="outlined"
                      size="small"
                      onClick={(e) => deleteAnnc(announcement)}
                    >
                      Delete Announcement
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </Dialog>
    )
  );
};

const DescriptionBlock = () => {
  const {openAdminWebFilesPage,setOpenAdminWebFilesPage} = useAnnouncements();
  return (
    <Typography>
      <ul>
        <li>
          A title and some text are required for the announcement, and an icon is required if there is a link.
        </li>
        <li>
          Enter the Expiration Date/Time in "mm/dd/yyyy hh:mm" format. For an announcement with no Expiration Date/Time, clear that field.
        </li>
        <li>
          With respect to announcement categories:
          <ul>
            <li>
              An announcement must have a category, and High Priority page cannot be the only category.
            </li>
            <li>
              An announcement cannot be more than one of Construction, Transit, and Weather. 
            </li>
            <li>
              A Construction or Weather announcement can also be a News Item. A Transit announcement cannot be a New Item. (An announcement can be a News Item only.) 
            </li>
            <li>
              Any announcement can also be High Priority Page (as appropriate).
            </li>
          </ul>
        </li>
        <li>
          The "Event ID" is the ID of a construction or special event associated with the announcemnet.
        </li>
        <li>
          Icons may be uploaded on the <span>
          <Link
          style={{textDecoration:'none'}}
          className="hyper-links"
          onClick={(e) => {setOpenAdminWebFilesPage(true)}}
        >
          Admin Web File
        </Link>
        </span> page. Refresh this page to view newly uploaded icons and/or images.
        </li>
      </ul>
      {/* <Link
          style={{textDecoration:'none'}}
          className="hyper-links"
          onClick={(e) => {setOpenAdminWebFilesPage(true)}}
        >
          OpenWebFilesAdmin
        </Link> */}
    </Typography>
  )
};

export default AnnouncementForm;
